import React from 'react'
import { useHistory } from 'react-router-dom';
import { formatPrice } from '../common/Functions';

function Footer({ totalAll }) {

    const history = useHistory();
    const redirectToPayment = () => {
        history.push("/payment");
    }
    if (!totalAll > 0) {
        return null;
    }


    return (
        <footer className="pg-table-booking">
            <div className="bottom-action" onClick={redirectToPayment}>
                <div className="left">
                    <p className="text-white"><span className="text-white d-inline-block pr-10">Total</span><span className="font-bold"> {formatPrice(totalAll)}</span></p>

                </div>
                <div className="right">
                    <button className="btn-bottom text-white">Make Payment <span className="fa fa-long-arrow-right"></span></button>
                </div>
            </div>
        </footer>
    )
}

export default Footer
